import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz-trans/client';

import FooterSimplifiedBlock from './components/FooterSimplifiedBlock';
import FooterSimplifiedBlockTitle from './components/FooterSimplifiedBlockTitle';
import FooterSimplifiedBlockList from './components/FooterSimplifiedBlockList';
import FooterSimplifiedLink from './components/FooterSimplifiedLink';

const SpotahomeFooter = props => {
  const spotahomeLinks = [
    {
      url: props.howItWorks,
      locoKey: 'footer.item.how_it_works'
    },
    {
      url: props.aboutUs,
      locoKey: 'footer.item.about_us'
    },
    {
      url: props.blog,
      locoKey: 'footer.item.blog'
    },
    {
      url: props.publishYourProperty,
      locoKey: 'footer.label.landlords'
    }
  ];
  const NO_FOLLOW_PAGES = [props.privacyPolicies, props.cookiesPolicy];
  return (
    <FooterSimplifiedBlock>
      <FooterSimplifiedBlockTitle text="Spotahome" />
      <FooterSimplifiedBlockList>
        {spotahomeLinks.map(({ locoKey, url }) => (
          <FooterSimplifiedLink
            key={locoKey}
            href={url}
            rel={NO_FOLLOW_PAGES.includes(url) ? 'nofollow' : ''}
          >
            {trans(locoKey)}
          </FooterSimplifiedLink>
        ))}
      </FooterSimplifiedBlockList>
    </FooterSimplifiedBlock>
  );
};

SpotahomeFooter.propTypes = {
  aboutUs: PropTypes.string.isRequired,
  howItWorks: PropTypes.string.isRequired,
  cookiesPolicy: PropTypes.string.isRequired,
  privacyPolicies: PropTypes.string.isRequired,
  blog: PropTypes.string.isRequired,
  publishYourProperty: PropTypes.string.isRequired
};

export default SpotahomeFooter;
